import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
  width: 100%;
`;

export const TextCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
  width: 100%;
`;

export const Questao = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  flex-wrap: nowrap;
  width:100%;
  margin: 1rem 0;
`;

export const MenuSelect = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  flex-wrap: nowrap;
  width:100%;
  /* gap: 1rem; */
  margin: 0.5rem 0;
  border-radius: 1rem;
  border: 1px solid var(--primary);
  background-color: var(--softGray);
  /* transition-property: box-shadow; */
  /* transition-property: transform; */
  /* transition-duration: 0.5s; */
  :hover{
    background-color: var(--softBlue);
    /* box-shadow: -5px 5px 2px var(--darkGray); */
    /* transform: scale(1.01); */
    transform: scale(0.99);
    color: var(--secondary);
  }
  cursor: pointer;
`;

export const Section = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  width:100%;
`;

export const ContainerGraph = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 2rem;
`;


export const List = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
  margin: 0 2rem 0 2rem;
`;